import { render, staticRenderFns } from "./IngresoCPCfdiRelacionado.vue?vue&type=template&id=0fd53374&"
import script from "./IngresoCPCfdiRelacionado.vue?vue&type=script&lang=js&"
export * from "./IngresoCPCfdiRelacionado.vue?vue&type=script&lang=js&"
import style0 from "./IngresoCPCfdiRelacionado.vue?vue&type=style&index=0&id=0fd53374&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports